/**
 * Utils for calculating precise age based on birth dates.
 */

export const calculateAge = (birthDateString, referenceDateString = new Date()) => {
  if (!birthDateString) return { years: '', months: '', days: '', totalMonths: '' };

  // Prevenir desfaces de zona horaria forzando a medianoche local si solo viene YYYY-MM-DD
  const normalizedBirth = birthDateString.includes('T') || birthDateString.includes(' ') 
    ? birthDateString 
    : `${birthDateString}T00:00:00`;
    
  const birthDate = new Date(normalizedBirth);
  const refDate = new Date(referenceDateString);

  if (isNaN(birthDate.getTime())) {
      return { years: '', months: '', days: '', totalMonths: '' };
  }

  let years = refDate.getFullYear() - birthDate.getFullYear();
  let months = refDate.getMonth() - birthDate.getMonth();
  let days = refDate.getDate() - birthDate.getDate();

  if (days < 0) {
    months -= 1;
    // Días que tiene el mes anterior al de la fecha de referencia
    const prevMonthDate = new Date(refDate.getFullYear(), refDate.getMonth(), 0);
    days += prevMonthDate.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  const totalMonths = (years * 12) + months;

  // Si se ingresa una fecha futura, por seguridad marcamos cero
  if (years < 0 || totalMonths < 0) {
    return { years: 0, months: 0, days: 0, totalMonths: 0 };
  }

  return {
    years,
    months,
    days,
    totalMonths
  };
};
